import { axiosInstance } from '@/utils/lib/axios';
import { env } from '@/utils/constants/env';

export interface UserOrgRoleResponse {
  org_chart_node_id?: number;
  is_manager: boolean;
  role: 'MANAGER' | 'EMPLOYEE';
  can_create_kpi_for_team: boolean;
}

export interface User {
  id: number;
  name: string;
  email: string;
  avatar_url?: string;
}

export interface OrgChartNodeUserResponse {
  id: number;
  org_chart_node_id: number;
  user_id: number;
  email: string;
  user: User;
}

export type MyTeamResponse = OrgChartNodeUserResponse[];
export type MySuperiorResponse = OrgChartNodeUserResponse[];

export const OrgChartService = {
  getMyOrgRole: async (tenantId: number): Promise<UserOrgRoleResponse> => {
    const response = await axiosInstance.get<UserOrgRoleResponse>(
      `${env.apiTasklistBaseUrl}/api/v1/compro/org-chart/tenant/${tenantId}/my-role`,
    );
    return response.data;
  },

  getMyTeam: async (tenantId: number): Promise<MyTeamResponse> => {
    const response = await axiosInstance.get<MyTeamResponse>(
      `${env.apiTasklistBaseUrl}/api/v1/compro/org-chart/tenant/${tenantId}/my-team`,
    );
    return response.data;
  },

  getMySuperior: async (tenantId: number): Promise<MySuperiorResponse> => {
    const response = await axiosInstance.get<MySuperiorResponse>(
      `${env.apiTasklistBaseUrl}/api/v1/compro/org-chart/tenant/${tenantId}/my-superior`,
    );
    return response.data;
  },
};
